(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cmp-preorder-restock"] && !Shopify.designMode) return;
  try {
    (function () {
    var REVISION = '2026-10-15';
    function send(path, key, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({ data: body }),
      }).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
      });
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cmp-notify-open]');
      if (!open) return;
      var notify = open.closest('[data-cmp-notify]');
      notify.dataset.state = 'open';
      open.setAttribute('aria-expanded', 'true');
      notify.querySelector('[data-cmp-notify-email]').focus();
    });
    function submit(notify) {
      var form = notify.querySelector('[data-cmp-notify-form]');
      var box = form.closest('[data-cmp-preorder-restock]');
      var msg = form.querySelector('[data-cmp-notify-msg]');
      var field = form.querySelector('[data-cmp-notify-email]');
      var email = field.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.textContent = notify.dataset.tInvalid;
        return;
      }
      msg.textContent = '';
      var button = form.querySelector('[data-cmp-notify-submit]');
      button.disabled = true;
      var key = notify.dataset.key;
      var id = box.dataset.cmpRestockVariantId;
      var newsletter = form.querySelector('[data-cmp-notify-newsletter]');
      var wantsNews = Boolean(notify.dataset.list && newsletter && newsletter.checked);
      if (notify.dataset.sheet) {
        fetch(notify.dataset.sheet, {
          method: 'POST',
          keepalive: true,
          body: new URLSearchParams({
            email: email,
            variante: box.dataset.cmpVariant,
            variant_id: id,
            produkt: notify.dataset.product,
            url: notify.dataset.url + '?variant=' + id,
            nachschub: box.dataset.cmpRestockDate,
            sprache: notify.dataset.locale,
            newsletter: wantsNews ? '1' : '0',
          }),
        }).catch(function () {});
      }
      /* Ohne Klaviyo ist die Tabelle der einzige Weg: das Danke sofort, wie im Magazin. */
      if (!key) {
        notify.dataset.state = 'done';
        button.disabled = false;
        return;
      }
      var requests = [
        send('events', key, {
          type: 'event',
          attributes: {
            unique_id: 'nachschub-' + id,
            properties: {
              VariantId: id,
              Produkt: notify.dataset.product,
              Variante: box.dataset.cmpVariant,
              ProduktURL: notify.dataset.url + '?variant=' + id,
              Nachschub: box.dataset.cmpRestockDate,
              Sprache: notify.dataset.locale,
            },
            metric: { data: { type: 'metric', attributes: { name: 'Nachschub angefragt' } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: { Sprache: notify.dataset.locale } } } },
          },
        }),
      ];
      if (wantsNews) {
        requests.push(send('subscriptions', key, {
          type: 'subscription',
          attributes: {
            custom_source: 'Nachschub-Benachrichtigung',
            profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
          },
          relationships: { list: { data: { type: 'list', id: notify.dataset.list } } },
        }));
      }
      Promise.all(requests).then(function () {
        notify.dataset.state = 'done';
      }, function () {
        msg.textContent = notify.dataset.tError;
      }).then(function () {
        button.disabled = false;
      });
    }
    document.addEventListener('click', function (e) {
      var button = e.target.closest('[data-cmp-notify-submit]');
      if (button) submit(button.closest('[data-cmp-notify]'));
    });
    /* Enter im Feld schickt ab, ohne das Formular des Kaufbuttons drumherum abzuschicken. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-cmp-notify-email]')) return;
      e.preventDefault();
      submit(e.target.closest('[data-cmp-notify]'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cmp-product-card"] && !Shopify.designMode) return;
  try {
    // Farbpunkte: Bild, Farbname und Links der Karte wechseln — ein delegierter Listener für alle Karten
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-cmp-pc-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-cmp-pc]');
    card.querySelectorAll('[data-cmp-pc-swatch]').forEach((s) => s.setAttribute('aria-checked', String(s === swatch)));
    const img = card.querySelector('.cmp-pc__img');
    if (img && swatch.dataset.src) {
      img.srcset = swatch.dataset.srcset || '';
      img.src = swatch.dataset.src;
    }
    const color = card.querySelector('[data-cmp-pc-color]');
    if (color) color.textContent = swatch.dataset.color;
    if (swatch.dataset.url) card.querySelectorAll('[data-cmp-pc-link]').forEach((a) => (a.href = swatch.dataset.url));
  });
  } catch(e) { console.error(e); }
})();

})();
